import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export let OnePartnerPageThunk = createAsyncThunk(
	"Partners/OnePartnerPageThunk",
	async (arg, ThunkApi) => {
		let { rejectWithValue } = ThunkApi;
		try {
			let res = await axios.get(`/api/admin/partners/${arg?.id}`);

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data.data);
		}
	}
);
